import React, { FC } from "react";
import { withServices } from "../../hocs/withServices";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AppContainer = (App: FC<any>) =>
  withServices(function Callback() {
    return (
      <>
        <App />
      </>
    );
  });
